@if(details()?.availMeetings; as meetings){
<schedule-viewer-part [selectedSlots]="meetings.selectedMeetingSlots" [numMeetings]="meetings.numMeetings" [blockoutSlots]="blockoutSlots()"
	[timeZoneId]="details()?.participant?.standardFourTimeZoneId">
</schedule-viewer-part>
} @else {
<common-message alertType='info'>
	No Schedule Information Available
</common-message>
}